import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './login.css';
import icon from '../Components/Logo.jpeg'

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const togglePassword = () => setShowPassword((prev) => !prev);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://kmtea.onrender.com/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ empid: username, password }),
            });

            const data = await response.json();

            if (data.success && data.employee) {
                localStorage.setItem('user', JSON.stringify({
                    empid: data.employee.empid,
                    empname: data.employee.empname,
                    role: data.employee.role
                }));

                if (data.employee.role === 'admin') {
                    navigate('/dashboard');
                } else if (data.employee.role === 'employee') {
                    navigate('/emppage');
                } else {
                    setError('Unknown role');
                }
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            setError('Server error');
            console.error('Login error:', err);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img
                    src={icon}
                   
                    alt="Bot Icon"
                    className="bot-icon"
                />
                <h2>Welcome Back</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Employee ID"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <div className="password-field">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <span onClick={togglePassword} className="toggle-eye">
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                    {error && <p className="error">{error}</p>}
                    <button type="submit">Login</button>
                </form>
            </div>
        </div>
    );
}

export default Login;
